import { FooterCardType } from '../../custom-types/footer';
import { toImage, toLink, toText } from '../../fields';
import { Image } from '../../fields/image';
import { Link } from '../../fields/link';

const multipleCardsContainer = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
): MultipleCardsContainer | undefined => {
  const imageTitle = toImage(data?.primary?.image_title);
  const textTitle = toText(data?.primary?.text_title);

  const tiles = data?.items.map(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (item: Record<string, any>): MultipleCardTile => {
      const image = toImage(item?.image);
      const ctaLabel = toText(item?.ctaLabel);
      const ctaLink = toLink(item?.ctaLink);

      if (!image || !ctaLabel || !ctaLink) {
        return undefined;
      }

      return {
        image,
        ctaLabel,
        ctaLink,
      };
    }
  );

  return {
    type: FooterCardType.MULTIPLE,
    imageTitle,
    textTitle,
    tiles,
  };
};

export type MultipleCardTile = {
  image: Image;
  ctaLabel: string;
  ctaLink: Link;
};

export type MultipleCardsContainer = {
  type: string;
  imageTitle: Image;
  textTitle: string | void;
  tiles: MultipleCardTile[];
};

export default multipleCardsContainer;
